import styled from 'styled-components';
import CLButton from '../../../components/CLButton';

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 30px;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const FilterContainer = styled.div`
  display: flex;
`;

export const ResetButton = styled(CLButton)`
  margin-left: 16px;
`;

export const Field = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;

  &:last-child {
    margin-bottom: 0;
  }

  select {
    width: 204px;
  }

  .range {
    display: flex;
    width: 204px;
    gap: 16px;
    margin-left: 24px;

    input {
      flex: 1;
    }
  }
`;

export const Label = styled.label`
  [class*=" cl-"] {
    margin-right: 8px;
    font-size: 14px;
  }
`;
